import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  // 登录
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/login.vue')
  },
  // 注册
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '../views/register.vue')
  },
  // 忘记密码
  {
    path: '/forgetPass',
    name: 'forgetPass',
    component: () => import(/* webpackChunkName: "forgetPass" */ '../views/forgetPass.vue')
  },
  // 首页
  {
    path: '/home',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
  },
  // 企业认证
  {
    path: '/authentication',
    name: 'authentication',
    component: () => import(/* webpackChunkName: "authentication" */ '../views/authentication.vue')
  },

  // 企业变更
  {
    path: '/biangeng',
    name: 'biangeng',
    component: () => import(/* webpackChunkName: "biangeng" */ '../views/bianGeng.vue')
  },
  // 新增预申报
  {
    path: '/grantlist',
    name: 'grantlist',
    component: () => import(/* webpackChunkName: "grantlist" */ '../views/grantlist.vue')
  },
  // 手机上传
  {
    path: '/upload',
    name: 'upload',
    component: () => import(/* webpackChunkName: "upload" */ '../views/upload.vue')
  },
  // 企业认证手机上传
  {
    path: '/uploadAuthertication',
    name: 'uploadAuthertication',
    component: () => import(/* webpackChunkName: "uploadAuthertication" */ '../views/uploadAuthertication.vue')
  },
  // 预申报发放调运单
  {
    path: '/wayBill',
    name: 'wayBill',
    component: () => import(/* webpackChunkName: "wayBill" */ '../views/wayBill.vue')
  },
  // 非预申报发放调运单
  {
    path: '/unWayBill',
    name: 'unWayBill',
    component: () => import(/* webpackChunkName: "unWayBill" */ '../views/unWayBill.vue')
  },
  // 手机上传身份证
  {
    path: '/uploadCard',
    name: 'uploadCard',
    component: () => import(/* webpackChunkName: "uploadCard" */ '../views/uploadCard.vue')
  },
  // 企业用户手机上传身份证
  {
    path: '/uploadComUser',
    name: 'uploadComUser',
    component: () => import(/* webpackChunkName: "uploadComUser" */ '../views/uploadComUser.vue')
  },
  // 矿云通专款打印
  {
    path: '/print',
    name: 'print',
    component: () => import(/* webpackChunkName: "print" */ '../views/print.vue')
  },
  // 开户凭证打印
  {
    path: '/certificatePrint',
    name: 'certificatePrint',
    component: () => import(/* webpackChunkName: "certificatePrint" */ '../views/certificatePrint.vue')
  }
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
});

// 解决页面切换后滚动条就消失了
router.afterEach((to, from, next) => {
  document.querySelector('body').setAttribute('style', 'overflow: auto !important;');
});

export default router;
